import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { userselectedprocess } from "../api/api";

const Navigationbar = ({ pages }) => {
  const [renderpage, setRenderpage] = useState();
  const [page, setPage] = useState([]);
  // const list = [1, 2, 3, 4, 5];
  const { fileId, category } = useParams();

  useEffect(() => {
    fetchdata(fileId);
  }, []);

  const fetchdata = async (fileId) => {
    try {
      let data = await userselectedprocess(fileId, category);
      if (data.data) {
        setRenderpage(data.data);
      } else {
        alert(data.error.message);
      }
    } catch (e) {
      alert(e);
    }
  };

  useEffect(() => {
    statuschange();
  }, [category, renderpage]);

  // useEffect(() => {
  //   statuschange();
  // }, [renderpage]);

  const statuschange = () => {
    renderpage?.forEach((element) => {
      if (!page.includes(element) && element <= category) {
        setPage((prev) => [...prev, element]);
      } else {
        setPage((prev) => prev.filter((item) => item < category));
      }
    });
  };

  if (page) {
    console.log(page);
  }

  return (
    <div className="flex w-full justify-center min-h-[100px]">
      <div className="flex w-10/12 justify-center items-center gap-2">
        {renderpage?.map((items, i) => (
          <>
            <div
              key={i}
              className={`relative h-6 w-10 max-w-[25px] rounded-[8px] ${
                page?.includes(items) ? "completed" : "future"
              } ${
                items.toString() === category.toString()
                  ? "current"
                  : "bg-[#B2B2AD]"
              }`}
            >
              <p className="absolute top-[120%] w-[100px] -left-[150%]">{`stage ${
                i + 1
              }`}</p>
            </div>
            <hr className={`w-[20%] last:hidden  ${
               page?.includes(items) ? "border-highlight":"border-[#B2B2AD]"
            }`}></hr>
          </>
        ))}
      </div>
    </div>
  );
};

export default Navigationbar;
